import script from "./ReplaceHardwareDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReplaceHardwareDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ReplaceHardwareDialog.vue?vue&type=style&index=0&id=4b1c11b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b1c11b4"]])

export default __exports__